<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-radio-group v-model="value">
          <el-radio-button v-for="(val, key) in typeData.data" :key="key" :label="val.value" text-color="#475eb7" fill="#475eb7">{{ val.label }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "RadioComp",
  props: ["type-data", "w50", "w100", "width"],
  components: {},
  data() {
    return {
      value:
        this.typeData.value || this.typeData.value == ""
          ? this.typeData.value
          : null
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>
